export const isEmptyObject = (obj: any): boolean =>
  !(
    obj &&
    Object.keys(obj).length !== 0 &&
    Object.getPrototypeOf(obj) === Object.prototype
  );

export const camelize = (str: any) => {
  return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word: any, index: number) {
    return index === 0 ? word.toLowerCase() : word.toUpperCase();
  }).replace(/\s+/g, '');
}

export const bannerStringGenerator = (role: string, managedEquipment: boolean) => {
  if (role === "customerQuote") {
    return "customerQuote_banner";
  }
  return `${role ? role : "carrierDriver"}_${managedEquipment ? "manage" : "nonManage"}_banner`;
}
export const footerkeyGenerator = (role: string) => {
  if (role === "customerQuote") {
    return "FPWFooterQuoteOrchestrator";
  }
  return role === "carrierDispatcher" ? "FPWFooterDispatcherOrchestrator" : "FPWFooterDriverOrchestrator";
}
export const adSign = (role: string) => {
  if (role === "customerQuote") {
    return "dynamicFPWMarginQuote";
  }
  return role === "carrierDispatcher" ? "dynamicFPWMarginDispatcher" : "dynamicFPWMarginDriver";
}
